import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createContact,
  fetchContacts,
  type CreateContactPayload,
  type UpdateContactPayload,
  updateContact,
} from '../queries/contacts.queries'

export const useContacts = () =>
  useQuery({
    queryKey: ['contacts'],
    queryFn: fetchContacts,
  })

export const useCreateContact = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: CreateContactPayload) => createContact(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] })
      queryClient.invalidateQueries({ queryKey: ['store-projects'] })
    },
  })
}

export const useUpdateContact = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpdateContactPayload) => updateContact(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['contacts'] })
      queryClient.invalidateQueries({ queryKey: ['store-projects'] })
    },
  })
}
